var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 13.3335H19.3334C17.8607 13.3335 16.6667 14.5274 16.6667 16.0002V32.0002C16.6667 33.4729 17.8607 34.6668 19.3334 34.6668H28.6667C30.1395 34.6668 31.3334 33.4729 31.3334 32.0002V16.0002C31.3334 14.5274 30.1395 13.3335 28.6667 13.3335Z",
    stroke: "#1B2559",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 16H20.0001C19.2637 16 18.6667 16.597 18.6667 17.3333V21.3333C18.6667 22.0697 19.2637 22.6667 20.0001 22.6667H28.0001C28.7365 22.6667 29.3334 22.0697 29.3334 21.3333V17.3333C29.3334 16.597 28.7365 16 28.0001 16Z",
    stroke: "#1B2559",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 31.9998C25.4727 31.9998 26.6666 30.8059 26.6666 29.3332C26.6666 27.8604 25.4727 26.6665 23.9999 26.6665C22.5272 26.6665 21.3333 27.8604 21.3333 29.3332C21.3333 30.8059 22.5272 31.9998 23.9999 31.9998Z",
    stroke: "#1B2559",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 29.9998C24.3681 29.9998 24.6666 29.7014 24.6666 29.3332C24.6666 28.965 24.3681 28.6665 23.9999 28.6665C23.6317 28.6665 23.3333 28.965 23.3333 29.3332C23.3333 29.7014 23.6317 29.9998 23.9999 29.9998Z",
    fill: "#1B2559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/Devices.9e70394d312b0fdb292f2518193333a2.svg";
export { ForwardRef as ReactComponent };